import { all, delay } from '@redux-saga/core/effects';
import { call, spawn } from 'redux-saga/effects';
import codePanelSaga from './components/CodePanel/saga';
import navigationBarSaga from './components/NavigationBar/saga';
import googleAnalyticsSaga from './components/GoogleAnalytics/saga';
import exampleGallerySaga from './components/ExampleGallery/saga';
import environmentSettingSaga from './components/EnvironmentSetting/saga';
import operationsMenuSaga from './components/OperationsMenu/saga';

export default function* rootSaga() {
  // Array to handle more than one saga
  const sagas = [
    codePanelSaga,
    navigationBarSaga,
    googleAnalyticsSaga,
    exampleGallerySaga,
    environmentSettingSaga,
    operationsMenuSaga,
  ];
  // Restart each saga of rootSaga in case of failure
  yield all(
    sagas.map((saga) =>
      spawn(function* restart() {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            console.log(e);
          }
          // Delay the saga restarting by 100 milliseconds
          yield delay(100);
        }
      }),
    ),
  );
}
